import dynamic from 'next/dynamic'
import React from 'react'
import styled from 'styled-components'

const DMPrimaryAltButton = dynamic(
  () =>
    import('@decormatters/dm-theme').then(
      component => component.DMPrimaryAltButton
    ),
  { ssr: false }
)

const EntryContainer = styled.div`
  width: 100%;

  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  padding: 12px 0;
  margin: 0;

  font-size: 18px;
  font-weight: 700;
  user-select: none;

  @media (min-width: 1200px) {
    font-size: 18px;
  }
`

const EntryTitle = styled.div`
  font-weight: 700;
  margin-bottom: 15px;
`

const EntryBodyContainer = styled.div`
  border-radius: 10px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  padding: ${props => (props.transparent ? '0' : '10px 10px 10px 13px')};
  background: ${props => (props.transparent ? 'transparent' : '#f5f5f5')};
  border-radius: 10px;
`

const ButtonContainer = styled.button`
  border: 0;
  border-radius: 10px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  padding: ${props => (props.transparent ? '0' : '10px 10px 10px 13px')};
  background: ${props => (props.transparent ? 'transparent' : '#f5f5f5')};
  border-radius: 10px;
  text-align: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: #000;

  &:hover {
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
    background: ${({ onClick }) => (onClick ? '#ddd' : '#f5f5f5')};
  }
`

const CustomButton = styled(DMPrimaryAltButton)`
  background: white;
`

const InfoContainer = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
  margin-left: 12px;
`

const MaterialIcon = styled.svg`
  height: 33px;
  width: 33px;
`

const MaterialImg = styled.img`
  height: 33px;
  width: 33px;
`

const Actionable = ({
  icon,
  img,
  alt,
  title,
  children,
  actionTitle,
  onButtonClick,
  onContainerClick,
  transparent,
  ...props
}) => {
  const Body = onContainerClick ? ButtonContainer : EntryBodyContainer

  const handleButtonClick = e => {
    if (!onButtonClick) return
    onButtonClick()
    e.stopPropagation()
  }

  return (
    <EntryContainer {...props}>
      <EntryTitle>{title}</EntryTitle>
      <Body transparent={transparent} onClick={onContainerClick}>
        {img && <MaterialImg src={img} alt={alt} />}
        {icon && <MaterialIcon as={icon} />}
        {(img || icon) && <InfoContainer>{children}</InfoContainer>}
        {!img && !icon && children}
        {actionTitle && (
          <CustomButton size="sm" onClick={handleButtonClick}>
            {actionTitle}
          </CustomButton>
        )}
      </Body>
    </EntryContainer>
  )
}

export default Actionable
